import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { getAgendaWeekAppointments, createAppointment, closeAppointment, promptCompleteAppointment, promptCancelAppointment, closeAllAppointmentsForDay, openAppointment } from 'state/actions'
import { getSelectedAgenda, getAppointmentsFromWeek } from 'lib/reader'
import { getCurrentDate, dateThreeMonthsFromNow } from 'lib/helper'

import AppointmentControlScreen from 'components/_Screens/AppointmentControl'

class AppointmentControlContainer extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      date: null,
    }
    this.onLoadAppointments = this.onLoadAppointments.bind(this)
    this.refresh = this.refresh.bind(this)
    this.onCloseAppointment = this.onCloseAppointment.bind(this)
    this.onOpenAppointment = this.onOpenAppointment.bind(this)
    this.onCreateAppointmentForDay = this.onCreateAppointmentForDay.bind(this)
    this.onCloseAllAppointmentsForDay = this.onCloseAllAppointmentsForDay.bind(this)
  }

  // Load with default today date
  UNSAFE_componentWillMount() {
    this.onLoadAppointments(getCurrentDate())
  }
  componentDidUpdate(prevProps) {
    // Update report when agenda changes
    if (prevProps.selectedAgenda.id !== this.props.selectedAgenda.id && this.state.date) {
      this.onLoadAppointments(this.state.date)
    }
  }

  onLoadAppointments(date) {
    const { selectedAgenda, getAgendaWeekAppointments } = this.props
    this.setState({ date })
    getAgendaWeekAppointments({ ...date, id: selectedAgenda.id })
  }
  refresh() {
    const { selectedAgenda, getAgendaWeekAppointments } = this.props
    const { date } = this.state
    getAgendaWeekAppointments({ ...date, id: selectedAgenda.id })
  }
  onCloseAppointment(appointment) {
    this.props.closeAppointment({ id: appointment.appointmentId})
  }
  onOpenAppointment(appointment) {
    this.props.openAppointment({ id: appointment.appointmentId })
  }
  onCompleteAppointment(appointment) {
    this.props.openAppointment({ id: appointment.appointmentId })
  }
  onCancelAppointment(appointment) {
    this.props.openAppointment({ id: appointment.appointmentId })
  }
  onCreateAppointmentForDay(date, minutes) {
    const { selectedAgenda: { id }, createAppointment } = this.props
    createAppointment({ id, ...date, minutes })
  }
  onCloseAllAppointmentsForDay(date) {
    const { selectedAgenda: { id }, closeAllAppointmentsForDay } = this.props
    closeAllAppointmentsForDay({ id, ...date })
  }

  render() {
    const { appointments, onAppointmentStart, promptCompleteAppointment, promptCancelAppointment, ui, selectedAppointment } = this.props
    return (
      <AppointmentControlScreen
        appointments={appointments}
        minDate={new Date()}
        maxDate={dateThreeMonthsFromNow().toDate()}
        onLoadAppointments={this.onLoadAppointments}
        onRefresh={this.refresh}
        onAppointmentClose={this.onCloseAppointment}
        onAppointmentOpen={this.onOpenAppointment}
        onAppointmentStart={onAppointmentStart}
        onAppointmentComplete={promptCompleteAppointment}
        onAppointmentCancel={promptCancelAppointment}
        onAppointmentCreateForDay={this.onCreateAppointmentForDay}
        onAppointmentCloseAllForDay={this.onCloseAllAppointmentsForDay}
        ui={ui}
      />
    )
  }
}

AppointmentControlContainer.propTypes = {
  appointments: PropTypes.array.isRequired,
  selectedAgenda: PropTypes.object.isRequired,
  ui: PropTypes.object.isRequired,
  onAppointmentStart:PropTypes.func.isRequired
}

const mapStateToProps = (state) => ({
  selectedAgenda: getSelectedAgenda(state),
  appointments: getAppointmentsFromWeek(state),
  ui: state.ui,
})

export default connect(
  mapStateToProps,
  { getAgendaWeekAppointments, createAppointment, closeAppointment, promptCompleteAppointment, promptCancelAppointment, closeAllAppointmentsForDay, openAppointment }
)(AppointmentControlContainer)



// WEBPACK FOOTER //
// ./src/containers/AppointmentsControl/index.js